import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root'
})
export class HelpCenterService {

  constructor(
    private readonly httpService: AmplifyHttpClient
  ) { }

  saveReportProblemInfo(request){
    return this.httpService.post<any>(`api/help-center/report-problem`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  saveFeedbackInfo(request) {
    return this.httpService.post<any>(`api/help-center/save-feedback`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  saveContactUsInfo(request) {
    return this.httpService.post<any>(`api/help-center/contact-us`, request).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }

  getFaqList() {
    return this.httpService.get<any>(`api/help-center/faq`).pipe(
      map(response => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      }),
    );
  }
}
